<template>
  <CCard>
    <CCardHeader>
      <strong>Prizes</strong>
    </CCardHeader>
    <CCardBody>
      <CRow>
        <CCol sm="12">
          <CInput label="Title" placeholder="Enter prize name" v-model="title" />
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="12">
          <CTextarea label="Body" placeholder="Enter prize body" v-model="body" />
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="12">
          <CTextarea label="Amount" placeholder="Enter amount" v-model="amount" />
        </CCol>
      </CRow>
      <CRow class="mt-5">
        <CCol sm="12">
          <CInputFile
              label="Image thumbnail"
              vertical
              v-model="image"
              ref="file"
              type="file"
              id="file"
              @change="onImageChange"
          />
          <!--<input type="file" class="form-control" v-on:change="onImageChange">-->
          <label class="text-danger">(Image Size should be (360 X 360) and less than 1 MB)</label>
        </CCol>
      </CRow>
    </CCardBody>
    <CCardFooter>
      <CButton @click="onSubmit" color="primary">
        <CIcon name="cil-check-circle" />Add Promotion
      </CButton>
    </CCardFooter>
  </CCard>
</template>

<script>
const ADMIN_URL = process.env.VUE_APP_ADMIN_URL;
export default {
  name: "BkashPromotionCreate",
  data() {
    return {
      title: "",
      body: "",
      amount: "",
      selectedUser: "",
      image: "",
      publishedStatus: false,
    };
  },
  methods: {
    onImageChange(e) {
      console.log("event", e[0]);
      this.image = e[0];
    },
    onSubmit(e) {
      e.preventDefault();
      let currentObj = this;
      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Accept: "application/json",
        },
      };

      let formData = new FormData();
      formData.append("title", this.title);
      formData.append("body", this.body);
      formData.append("amount", this.amount);
      // formData.append("created_by", this.selectedUser);
      // formData.append("published_status", this.publishedStatus);
      formData.append("image", this.image);
      // if(this.publishedStatus)
      // {
      //   formData.append("published_status",this.publishedStatus);
      // }

      this.$axios
          .post(`${ADMIN_URL}/prizes`, formData, config)
          .then((response) => {
            this.$swal("Success", response.data.message, "success");
            window.location.href = "/bkash-promotion";
          })
          .catch((error) => {
            console.log("Error  ... ", error.response);
            currentObj.output = error;
            this.$swal("Error", error.response.message, "error");
          });
    }
  }
};
</script>

<style scoped>
</style>
